/**
 * Reference-counted body scroll lock.
 *
 * Several overlays can be open at once on small viewports — the mobile menu,
 * the Ask Lab palette, the compare sheet. A naive per-component save/restore of
 * `document.body.style.overflow` nests incorrectly: the second overlay saves
 * the already-`hidden` value, and when both close the body is left stuck at
 * `overflow: hidden` forever. This shared counter saves the original overflow
 * on the first lock and restores it only when the last lock is released.
 *
 * SSR-safe: no-ops when `document` is unavailable.
 */

let count = 0;
let prevOverflow = '';

export function lockScroll(): void {
  if (typeof document === 'undefined') return;
  if (count === 0) {
    prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }
  count += 1;
}

export function unlockScroll(): void {
  if (typeof document === 'undefined') return;
  if (count === 0) return;
  count -= 1;
  if (count === 0) {
    document.body.style.overflow = prevOverflow;
  }
}
